import styled, { css } from 'styled-components';

export const SpaceBetween = styled.div<{ vertical?: boolean; center?: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  min-width: 100%;

  ${({ vertical }) =>
    vertical &&
    css`
      flex-direction: column;
      min-height: 100%;
    `}

  ${({ center }) => center && css`
    align-items: center;
  `}
`;
